import { render, staticRenderFns } from "./ClientV1.vue?vue&type=template&id=0e844d96&scoped=true&"
import script from "./ClientV1.vue?vue&type=script&lang=js&"
export * from "./ClientV1.vue?vue&type=script&lang=js&"
import style0 from "./ClientV1.vue?vue&type=style&index=0&id=0e844d96&scoped=true&lang=css&"
import style1 from "./ClientV1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e844d96",
  null
  
)

export default component.exports